import { Button, Modal, Stack } from "@assetwatch/ui";

type DeleteRequestDialogProps = {
  isPending: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  requestCount: number;
  requestNumber?: string;
  requestTitle?: string;
};

export function DeleteRequestDialog({
  isPending,
  onConfirm,
  onOpenChange,
  open,
  requestCount,
  requestNumber,
  requestTitle,
}: DeleteRequestDialogProps) {
  const isBulk = requestCount > 1;

  return (
    <Modal
      dismissible={!isPending}
      footer={
        <>
          <Button
            disabled={isPending}
            onClick={() => onOpenChange(false)}
            variant="ghost"
          >
            Cancel
          </Button>
          <Button
            intent="destructive"
            loading={isPending}
            loadingText="Deleting request"
            onClick={onConfirm}
          >
            Delete
          </Button>
        </>
      }
      onOpenChange={onOpenChange}
      open={open}
      title="Delete request?"
    >
      <Stack gap={16}>
        <p className="font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-subtle">
          {isBulk ? (
            <>This will flag-delete {requestCount} Work Requests.</>
          ) : (
            <>
              This will flag-delete{" "}
              <strong className="font-(family-name:--font-family-label) font-(number:--font-weight-semibold) text-text-default">
                {requestNumber}
              </strong>{" "}
              {requestTitle}.
            </>
          )}
        </p>
      </Stack>
    </Modal>
  );
}
